export const CSS = {
  lastVisibleRow: "last-visible-row",
};
